if (!customElements.get('complementary-products-rao')) {
  customElements.define(
    'complementary-products-rao',
    class ComplementaryProductsRao extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.cartDrawerElement = document.querySelector('cart-drawer');
        this.addToCartButtonElement = this.querySelector('.complementary-products-rao__add');
        this.totalPriceElement = this.querySelector('[data-total-price]');
        this.errorMessageElement = this.querySelector('.complementary-products-rao__error');

        this.addEventListener('change', this.handleSelectionChange.bind(this));
        this.addToCartButtonElement?.addEventListener('click', this.handleButtonClick.bind(this));

        this.updateTotal();
      }

      get selectedInputs() {
        return Array.from(this.querySelectorAll('.complementary-products-rao__input:checked'));
      }

      handleSelectionChange(event) {
        const input = event.target.closest('.complementary-products-rao__input');
        if (!input) return;

        const item = input.closest('.complementary-products-rao__item');
        item?.classList.toggle('is-selected', input.checked);
        this.updateTotal();
      }

      updateTotal() {
        const total = this.selectedInputs.reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);

        if (this.totalPriceElement) {
          this.totalPriceElement.innerHTML = FoxTheme.Currency.formatMoney(total, FoxTheme.settings.moneyFormat);
        }

        if (this.addToCartButtonElement) {
          if (this.selectedInputs.length) {
            this.addToCartButtonElement.removeAttribute('disabled');
          } else {
            this.addToCartButtonElement.setAttribute('disabled', 'disabled');
          }
        }
      }

      handleButtonClick(event) {
        event.preventDefault();
        this.lastClickedElement = event.currentTarget;

        const items = {
          items: this.selectedInputs.map((input) => ({
            id: Number(input.dataset.variantId || input.value),
            quantity: 1,
          })),
        };

        if (!items.items.length) return;

        if (document.body.classList.contains('cart-template') || FoxTheme.settings.cartType != 'drawer') {
          FoxTheme.utils.postLink(FoxTheme.routes.cart_add_url, {
            parameters: {
              ...items,
            },
          });
          return;
        }

        this.showErrorMessage();
        this.toggleButtonLoading(true);

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        const body = JSON.stringify({
          ...items,
          sections: sectionsToBundle,
          section_url: window.pathname,
        });

        fetch(`${FoxTheme.routes.cart_add_url}`, { ...FoxTheme.utils.fetchConfig('javascript'), ...{ body } })
          .then((response) => response.json())
          .then(async (parsedState) => {
            if (parsedState.status) {
              this.showErrorMessage(parsedState.description);
              return;
            }

            if (parsedState.status === 422) {
              document.dispatchEvent(
                new CustomEvent('product-ajax:error', {
                  detail: {
                    errorMessage: parsedState.description,
                  },
                })
              );
            } else {
              const cartJson = await (
                await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })
              ).json();
              cartJson['sections'] = parsedState['sections'];

              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
              document.dispatchEvent(
                new CustomEvent('product-ajax:added', {
                  detail: {
                    product: parsedState,
                  },
                })
              );
              this.cartDrawerElement && this.cartDrawerElement.show(this.lastClickedElement);
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.toggleButtonLoading(false);
          });
      }

      showErrorMessage(errorMessage = false) {
        if (!this.errorMessageElement) {
          if (errorMessage) alert(errorMessage);
          return;
        }

        this.errorMessageElement.hidden = !errorMessage;
        if (errorMessage) this.errorMessageElement.textContent = errorMessage;
      }

      toggleButtonLoading(status) {
        if (!this.addToCartButtonElement) return;

        if (status) {
          this.addToCartButtonElement.classList.add('btn--loading');
          this.addToCartButtonElement.setAttribute('disabled', 'disabled');
        } else {
          this.addToCartButtonElement.classList.remove('btn--loading');
          this.updateTotal();
        }
      }
    }
  );
}
